import { useState, useEffect } from 'react';
import { API_BASE_URL, getImageUrl } from '../config/api';

const useHeader = () => {
  const [headerContent, setHeaderContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHeaderContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/content/header`);
        if (!response.ok) {
          throw new Error(`Failed to fetch header content: ${response.statusText}`);
        }
        const data = await response.json();
        if (data.logo) {
          data.logo = getImageUrl(data.logo);
        }
        if (data.HomeLogo) {
          data.HomeLogo = getImageUrl(data.HomeLogo);
        }
        
        setHeaderContent(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching header content:', err);
        setError(err.message);
        setHeaderContent({
          logo: '/images/mainLogo.png',
          navigation: [
            { label: 'Home', path: '/' },
            { label: 'About us', path: '/about' },
            { label: 'Contact us', path: '/contact' }
          ]
        });
      } finally {
        setLoading(false);
      }
    };

    fetchHeaderContent();
  }, []);

  return { headerContent, loading, error };
};

export default useHeader;
